import type { Persona } from "./persona"

export const COLLECTION_FILTER_SIDE_PANEL_STATE_COOKIE_NAME =
  "collectionSidePanelState"
export const ACTIVITY_FILTER_SIDE_PANEL_STATE_COOKIE_NAME =
  "activitySidePanelState"
export const STATS_FILTER_SIDE_PANEL_STATE_COOKIE_NAME = "statsSidePanelState"
export const PROFILE_FILTER_SIDE_PANEL_STATE_COOKIE_NAME =
  "profileSidePanelState"
export const FILTER_SIDE_PANEL_STATE_COOKIE_NAME = "sidePanelState"
export const PORTFOLIO_FILTER_SIDE_PANEL_STATE_COOKIE_NAME =
  "portfolioSidePanelState"
export const WATCHLIST_FILTER_SIDE_PANEL_STATE_COOKIE_NAME =
  "watchlistSidePanelState"
export const TOKEN_WATCHLIST_FILTER_SIDE_PANEL_STATE_COOKIE_NAME =
  "tokenWatchlistSidePanelState"
export const CREATED_FILTER_SIDE_PANEL_STATE_COOKIE_NAME =
  "createdSidePanelState"
export const STUDIO_FILTER_SIDE_PANEL_STATE_COOKIE_NAME = "studioSidePanelState"
export const FILTER_SIDE_PANEL_STATE = {
  open: "open",
  closed: "closed",
} as const

export type FilterSidePanelState = keyof typeof FILTER_SIDE_PANEL_STATE

/**
 * The default filter panel state is based on the persona
 */
export const getDefaultFilterSidePanelState = (
  persona: Persona,
): FilterSidePanelState => {
  return persona === "collector" ? "open" : "open"
}

export function parseFilterSidePanelState(
  filterSidePanelState: string | undefined,
  persona: Persona,
  defaultFilterPanelState?: FilterSidePanelState,
): FilterSidePanelState {
  if (filterSidePanelState && filterSidePanelState in FILTER_SIDE_PANEL_STATE) {
    return filterSidePanelState as FilterSidePanelState
  }

  if (defaultFilterPanelState) {
    return defaultFilterPanelState
  }

  return getDefaultFilterSidePanelState(persona)
}

const filterSidePanelStates = Object.values(FILTER_SIDE_PANEL_STATE)

export function getFilterSidePanelStatesStaticParams() {
  return filterSidePanelStates.map(filterSidePanelState => ({
    filterSidePanelState,
  }))
}
